<div *ngIf="selectedChecklist" class="">
  <div class="flex flex-wrap card">
    <div class="flex-grow-1 pr-2 pb-2">
      <p-dropdown
        placeholder="Select Task Type"
        [options]="taskTypes"
        [(ngModel)]="selectedTaskTypeId"
      ></p-dropdown>
    </div>
    <div class="flex-shrink-1">
      <span
        style="
          line-height: 30px;
          display: inline-block;
          vertical-align: text-bottom;
          margin-right: 5px;
        "
      >
        {{ taskTypeEnabled ? 'Enabled' : 'Disabled' }}
      </span>
      <p-inputSwitch [(ngModel)]="taskTypeEnabled" [disabled]="checklistDisabled"></p-inputSwitch>
    </div>
  </div>
  <div class="ui-g card" *ngIf="selectedTaskTypeId">
    <div
      *ngIf="!isLocked"
      style="background-color: #eee; border-radius: 5px; padding: 5px 10px; margin-bottom: 7px"
    >
      <div>
        Enable/disable custom Checklist Steps for this Task Type below. You can change the order of
        the checklist steps by dragging the <i class="fa fa-bars"></i> icon. NOTE: Heading to
        Pick-up Location must be the first item and Complete Task must be the last Item
      </div>
    </div>

    <div class="ui-g-6 ui-sm-12">
      <div *ngIf="steps">
        <h2 class="sub-header-bar">Pick-up Checklist:</h2>
        <p-table [value]="pickupSteps" (onRowReorder)="reorderSteps(true, $event)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>Step Name</th>
              <th style="width: 8em" class="text-center">Type</th>
              <th style="width: 7em" class="text-center">Enabled</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index" [pReorderableRowDisabled]="index == 0">
              <td>
                <span
                  style="display: inline-block; width: 20px"
                  *ngIf="!isLocked && !checklistDisabled"
                >
                  <i
                    class="fa fa-bars link-grab"
                    [pReorderableRowHandle]="index"
                    *ngIf="index != 0 && !rowData.isEngineiusStep && taskTypeEnabled"
                  ></i>
                </span>
                {{ rowData['name'] }}
              </td>
              <td styleClass="text-center">
                <div class="text-center">
                  {{ rowData.isEngineiusStep ? 'Engineius' : 'Custom' }}
                </div>
              </td>
              <td class="text-center">
                <p-checkbox
                  (onChange)="updateSteps(selectedTaskTypeId, selectedChecklist.id, steps)"
                  *ngIf="!rowData.isEngineiusStep"
                  [disabled]="isLocked || checklistDisabled || !taskTypeEnabled"
                  binary="true"
                  [(ngModel)]="pickupSteps[index].isActive"
                ></p-checkbox>
                <p-checkbox
                  (onChange)="updateSteps(selectedTaskTypeId, selectedChecklist.id, steps)"
                  *ngIf="rowData.isEngineiusStep"
                  binary="true"
                  value="true"
                  [disabled]="true"
                  [(ngModel)]="setTrue"
                ></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="ui-g-6 ui-sm-12">
      <div *ngIf="steps">
        <h2 class="sub-header-bar">Drop-off Checklist:</h2>
        <p-table [value]="dropoffSteps" (onRowReorder)="reorderSteps(false, $event)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>Step Name</th>
              <th style="width: 8em" class="text-center">Type</th>
              <th style="width: 7em" class="text-center">Enabled</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr
              [pReorderableRow]="index"
              [pReorderableRowDisabled]="index == dropoffSteps.length - 1"
            >
              <td>
                <span
                  style="display: inline-block; width: 20px"
                  *ngIf="!isLocked && !checklistDisabled"
                >
                  <i
                    class="fa fa-bars link-grab"
                    [pReorderableRowHandle]="index"
                    *ngIf="index != 0 && !rowData.isEngineiusStep && taskTypeEnabled"
                  ></i>
                </span>
                {{ rowData['name'] }}
              </td>
              <td class="text-center">
                <div class="text-center">
                  {{ rowData.isEngineiusStep ? 'Engineius' : 'Custom' }}
                </div>
              </td>
              <td class="text-center">
                <p-checkbox
                  *ngIf="!rowData.isEngineiusStep"
                  [disabled]="isLocked || checklistDisabled || !taskTypeEnabled"
                  binary="true"
                  [(ngModel)]="dropoffSteps[index].isActive"
                ></p-checkbox>
                <p-checkbox
                  *ngIf="rowData.isEngineiusStep"
                  binary="true"
                  value="true"
                  [disabled]="true"
                  [(ngModel)]="setTrue"
                ></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="ui-g-12">
      <button
        pButton
        type="button"
        label="Copy to other Task Types"
        [icon]="saveMapIcon"
        class="green-btn ml-0"
        (click)="saveChecklistMapping(true)"
        [disabled]="
          !selectedChecklist || isBusy || isLocked || checklistDisabled || !taskTypeEnabled
        "
      ></button>
    </div>
  </div>
</div>
<div></div>
